import * as types from "./actionTypes";

const initialState = {
  loading: false,
  error: null,
  success: false,
  reportDropdowns: [],
  reportList: [],
  monthlyReport: [],
  projectStatusReport: [],
  projectDetailsReport: [],
  projectServiceReport: [],
  moduleTasksReport: [],
  employeeDetailsReport: [],
  moduleSearchReport: null,
  projectStatusList: [],
  projectClientDetailsList: [],
  projectEmployeeDetails: [],
  projectClientList: [],
  exportList: [],
};

const timesheetreportReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_TIMESHEET_REPORT_DROPDOWNS_REQUEST:
    case types.FETCH_TIMESHEET_REPORT_LIST_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_TIMESHEET_MONTHLY_REPORT_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_TIMESHEET_REPORT_DROPDOWNS_SUCCESS:
      return { ...state, loading: false, reportDropdowns: action.payload };

    case types.FETCH_TIMESHEET_REPORT_LIST_SUCCESS:
      return { ...state, loading: false, reportList: action.payload };

    case types.FETCH_TIMESHEET_MONTHLY_REPORT_SUCCESS:
      return { ...state, loading: false, monthlyReport: action.payload };

    case types.FETCH_TIMESHEET_REPORT_DROPDOWNS_FAILURE:
    case types.FETCH_TIMESHEET_REPORT_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_TIMESHEET_MONTHLY_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };


    case types.FETCH_TIMESHEET_TASK_STATUS_REPORT_REQUEST:
    case types.FETCH_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_TIMESHEET_TASK_STATUS_REPORT_SUCCESS:
      return { ...state, loading: false, reportList: action.payload };

    case types.FETCH_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT_SUCCESS:
      return { ...state, loading: false, reportList: action.payload };

    case types.FETCH_TIMESHEET_TASK_STATUS_REPORT_FAILURE:
    case types.FETCH_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.RESET_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT:
      return {
        ...state,
        reportList: [],
        loading: false,
        error: null,
      };

    // Project Status Report
    case types.FETCH_PROJECT_STATUS_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_PROJECT_STATUS_REPORT_SUCCESS:
      return { ...state, loading: false, projectStatusReport: action.payload };
    case types.FETCH_PROJECT_STATUS_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Project Details Report
    case types.FETCH_PROJECT_DETAILS_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_PROJECT_DETAILS_REPORT_SUCCESS:
      return { ...state, loading: false, projectDetailsReport: action.payload };
    case types.FETCH_PROJECT_DETAILS_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Project Service Report
    case types.FETCH_PROJECT_SERVICE_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_PROJECT_SERVICE_REPORT_SUCCESS:
      return { ...state, loading: false, projectServiceReport: action.payload };
    case types.FETCH_PROJECT_SERVICE_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Module Tasks Report
    case types.FETCH_MODULE_TASKS_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_MODULE_TASKS_REPORT_SUCCESS:
      return { ...state, loading: false, moduleTasksReport: action.payload };
    case types.FETCH_MODULE_TASKS_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Employee Details Report
    case types.FETCH_EMPLOYEE_DETAILS_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_EMPLOYEE_DETAILS_REPORT_SUCCESS:
      return { ...state, loading: false, employeeDetailsReport: action.payload };
    case types.FETCH_EMPLOYEE_DETAILS_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Module Search Report
    case types.FETCH_MODULE_SEARCH_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_MODULE_SEARCH_REPORT_SUCCESS:
      return { ...state, loading: false, moduleSearchReport: action.payload };
    case types.FETCH_MODULE_SEARCH_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Project Status List
    case types.FETCH_PROJECT_STATUS_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_PROJECT_STATUS_LIST_SUCCESS:
      return { ...state, loading: false, projectStatusList: action.payload };
    case types.FETCH_PROJECT_STATUS_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Project Client Details List
    case types.FETCH_PROJECT_CLIENT_DETAILS_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_PROJECT_CLIENT_DETAILS_LIST_SUCCESS:
      return { ...state, loading: false, projectClientDetailsList: action.payload };
    case types.FETCH_PROJECT_CLIENT_DETAILS_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Project Employee Details
    case types.FETCH_PROJECT_EMPLOYEE_DETAILS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_PROJECT_EMPLOYEE_DETAILS_SUCCESS:
      return { ...state, loading: false, projectEmployeeDetails: action.payload };
    case types.FETCH_PROJECT_EMPLOYEE_DETAILS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Project Client List
    case types.FETCH_PROJECT_CLIENT_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_PROJECT_CLIENT_LIST_SUCCESS:
      return { ...state, loading: false, projectClientList: action.payload };
    case types.FETCH_PROJECT_CLIENT_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_PROJECT_STATUS_EXPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_PROJECT_STATUS_EXPORT_SUCCESS:
      return { ...state, loading: false, exportList: action.payload };
    case types.FETCH_PROJECT_STATUS_EXPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default timesheetreportReducer;